const globalContext: any = {};

export default globalContext;
